import { render, staticRenderFns } from "./ExperimentItem.vue?vue&type=template&id=98399de6&"
import script from "./ExperimentItem.vue?vue&type=script&lang=js&"
export * from "./ExperimentItem.vue?vue&type=script&lang=js&"
import style0 from "./ExperimentItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ExperimentItem.vue"
export default component.exports